'use client'

import { cn } from '@brew/ui/cn'
import type { FormEvent, ReactNode } from 'react'
import {
  ROUNDED_SEARCH_BAR_CLASSNAME,
  ROUNDED_SEARCH_INPUT_CLASSNAME,
  ROUNDED_TOOLBAR_CONTROL_CLASSNAME,
} from '@/components/audience/rounded-search-bar-classes'

export {
  ROUNDED_SEARCH_BAR_CLASSNAME,
  ROUNDED_SEARCH_INPUT_CLASSNAME,
  ROUNDED_TOOLBAR_CONTROL_CLASSNAME,
}

export function RoundedSearchBar({
  onSubmit,
  className,
  children,
}: {
  onSubmit?: (event: FormEvent<HTMLFormElement>) => void
  className?: string
  children: ReactNode
}) {
  return (
    <form
      onSubmit={onSubmit ?? ((event) => event.preventDefault())}
      className={cn(ROUNDED_SEARCH_BAR_CLASSNAME, className)}
    >
      {children}
    </form>
  )
}
